import { inject, Injectable } from '@angular/core';
import { IElementResponse } from 'src/app/api/modules/core/dynamic/element/network/IElementResponse';
import { IResponse } from 'src/app/api/modules/core/network/IResponse';
import { DigitaServiceAPIService } from 'src/app/modules/core/services/network/digitaservice-api.service';

/**
 * Network side effects for the {@link ElementComponent}.
 *
 * State lives in the component (signals); this service owns only the API calls —
 * keeping the network boundary out of the component, with no shared state of its
 * own (hence `providedIn: 'root'`).
 */
@Injectable({
  providedIn: 'root',
})
export class ElementService {
  private readonly digitaServiceAPI = inject(DigitaServiceAPIService);

  /**
   * Fires an onReadyAPI event.
   *
   * @param api - the API end point if it is available.
   * @param event - the event detail from the element.
   */
  requestOnReadyAPI(api: string, event: object) {
    return this.digitaServiceAPI.data<IElementResponse>(api, event);
  }

  /**
   * Fires an onErrorAPI event.
   *
   * @param api - the API end point if it is available.
   * @param event - the event detail from the element.
   */
  requestOnErrorAPI(api: string, event: object) {
    return this.digitaServiceAPI.data<IElementResponse>(api, event);
  }

  /**
   * Fires an onEventAPI event.
   *
   * @param api - the API end point if it is available.
   * @param event - the event detail from the element.
   */
  requestOnEventAPI(api: string, event: object) {
    return this.digitaServiceAPI.data<IElementResponse>(api, event);
  }

  /**
   * Fires an onCompleteAPI event.
   *
   * @param api - the API end point if it is available.
   * @param event - the event detail from the element.
   */
  requestOnCompleteAPI(api: string, event: object) {
    return this.digitaServiceAPI.data<IElementResponse>(api, event, true);
  }

  /**
   * Fires an onHeartbeatAPI request.
   *
   * @param api - the API end point.
   * @param data - the heartbeat data payload.
   */
  requestOnHeartbeatAPI(api: string, data: Record<string, unknown>) {
    return this.digitaServiceAPI.data<IResponse>(api, data, true);
  }
}
